module.exports = __webpack_public_path__ + "static/media/4.f6b7960c.webp";